import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6l373r5919: FaireBrandEntity = {
  token: "b_6l373r5919",
  type: "brand",
  name: "LA RELAXED",
  avatarUrl: "https://cdn.faire.com/fastly/8ba251cc37ded86fec45f77f0c1272995310a096af7e8bb1aa45481309a868ee.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/24a8cd56740ba70395fc869eacd055d5ec598454c5f0c15f939b551f1e07c3a1.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/8ba251cc37ded86fec45f77f0c1272995310a096af7e8bb1aa45481309a868ee.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/24a8cd56740ba70395fc869eacd055d5ec598454c5f0c15f939b551f1e07c3a1.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 450,
  rating: 4.9,
  reviewCount: 41,
  isInsider: true,
  description: "We design and make everything - under one roof - in Los Angeles. We measure our impact in footsteps, not a footprint.  \n\nFrom our design studio, to pattern room, to the sample sewer, the cutting table to the production line and finally though \ninspection and our packing line, it takes under 100 steps to complete a garment.\n\nWe believe in sufficient, not excess, so we built our business on a limited run model. We don’t over produce and we\n don’t ever send a garment to landfill.\n\nThe absolute beating heart of the company is the community of people who design, create, and make LA RELAXED. \nThat is why we refuse to pay anything less than a living wages as we cultivate a respectful and collaborative atmosphere. \nWe are all about our people.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:02.578Z",
    importedBy: "entity-db-cli"
  }
};
